import React from 'react';
import { CheckBox } from 'sos-common/js/components/FormControls/CheckBox';
import { CheckBoxState } from 'sos-common/js/components/FormControls/CheckBox';
// This value must be same as it's backend counterpart: Global.StbContactFormConstants.Omdelning
const OMDELNING = '__omdelning';
interface IProps {
  redistributionHeading: string;
  redistributionPreamble: string;
  iWantRedistribution: string;
  isChecked: boolean;
  onChange: (state: CheckBoxState) => void;
}

export const Redistribution: React.FunctionComponent<IProps> = (props) => {
  return (
    <div>
      <hr className="formdivider" />
      {props.redistributionHeading && <h2>{props.redistributionHeading}</h2>}
      {props.redistributionPreamble && <p>{props.redistributionPreamble}</p>}
      {/* 
      stringValue of the following checkbox must be same as it's backend counterpart. 
      See StatsbidragService.cs -> SaveRekFormDataAsync() 
      */}
      <CheckBox
        value={props.isChecked}
        onChangeCallback={props.onChange}
        fieldName={OMDELNING}
        label={props.iWantRedistribution}
        stringValue="true"
      />
    </div>
  );
};
